<template>
  <div>
    <v-data-table :headers="headers" :items="items" :loading="loading">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <grid-cell
            :header="header"
            :row="props.item"
            v-for="(header, index) in headers"
            :key="index"
            @action="onAction"
          ></grid-cell>
        </tr>
      </template>
    </v-data-table>
    <v-dialog max-width="480" v-model="changeContractPerson">
      <v-card>
        <v-card-title class="headline" v-if="selectedCustomer.fullName">
          {{
            $t('@insurance/customerList/сhangeContactPersonDialog/title', {
              customerFullName: selectedCustomer.fullName,
            })
          }}
        </v-card-title>
        <v-card-text v-if="!selectedCustomer.isAdult">
          {{
            $t('@insurance/customerList/сhangeContactPersonDialog/contactPersonMustBeAdultMessage')
          }}
        </v-card-text>
        <v-card-text v-else-if="!selectedCustomer.mobileNumber">
          {{
            $t(
              '@insurance/customerList/сhangeContactPersonDialog/contactPersonMustHaveMobileMessage',
              { customerFullName: selectedCustomer.fullName },
            )
          }}
          <v-text-field
            color="green darken-1"
            :label="$t('@insurance/customerList/сhangeContactPersonDialog/phoneInputLabel') + ' *'"
            mask="0## ### ## ##"
            :placeholder="
              $t('@insurance/customerList/сhangeContactPersonDialog/phoneInputPlaceholder')
            "
            v-model="mobileNumberForNewContactPerson"
            :rules="[validateMobileNumber]"
            :error-messages="mobileNumberErrorMessage"
          />
        </v-card-text>
        <errors-list :errorMessage="errorMessage" />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.stop="closeModal">
            {{ $t('@insurance/customerList/сhangeContactPersonDialog/cancelButtonLabel') }}
          </v-btn>

          <v-btn
            color="green darken-1"
            flat
            :disabled="!isContactPersonChangeAllowed"
            @click.stop="onSubmit"
          >
            {{ $t('@insurance/customerList/сhangeContactPersonDialog/submitButtonLabel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorsList from '../../components/ErrorsList';
import GridCell from '../../components/GridCell';
import { getErrorMessage } from '../../errorHandlers';
import { catchException } from '../../plugins/bugsnag';

export default {
  components: {
    GridCell,
    ErrorsList,
  },

  props: {
    internalId: String,
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      changeContractPerson: false,
      selectedCustomer: {},
      mobileNumberForNewContactPerson: '',
      mobileNumberErrorMessage: null,
      errorMessage: null,
      headers: [
        {
          text: this.$t('@participantsList/personalNumberColumnHeader'),
          align: 'left',
          sortable: false,
          value: 'socialSecurityNumber',
        },
        { text: this.$t('@participantsList/fullNameColumnHeader'), value: 'fullName' },
        { text: this.$t('@participantsList/mobileNumberColumnHeader'), value: 'mobileNumber' },
        {
          text: this.$t('@participantsList/contactPersonColumnHeader'),
          width: 40,
          value: 'isContactPerson',
          format: (val) => !!val,
        },
        {
          text: this.$t('@participantsList/actionsColumnHeader'),
          width: 40,
          sortable: false,
          value: '&nbsp;',
          actions: (row) =>
            row.isContactPerson ? [] : [{ icon: 'swap_horiz', name: 'changeContractPersion' }],
        },
      ],
    };
  },

  methods: {
    onAction({ action, row }) {
      if (!action) {
        this.onClickRow(row);
        return;
      }

      if (action.name === 'changeContractPersion') {
        this.changeContractPerson = true;
        this.selectedCustomer = row;
        return;
      }
    },
    onClickRow(val) {
      this.$emit('select', val);
    },
    closeModal() {
      this.changeContractPerson = false;
      this.mobileNumberForNewContactPerson = '';
      this.mobileNumberErrorMessage = null;
      this.errorMessage = null;
      this.selectedCustomer = {};
    },
    async onSubmit() {
      if (!this.selectedCustomer.mobileNumber) {
        try {
          const customerUpdates = { mobilePhone: this.mobileNumberForNewContactPerson };
          const updateResult = await this.$http.put(
            `/api/customer/${this.selectedCustomer.id}`,
            customerUpdates,
          );

          this.selectedCustomer.mobileNumber = updateResult.mobilePhone;
        } catch (e) {
          this.mobileNumberErrorMessage = getErrorMessage(e);
          catchException(e);

          return;
        }
      }

      try {
        const payload = { customerId: this.selectedCustomer.id };

        await this.$http.put(`/api/insurances/${this.$props.internalId}/contract-person`, payload);

        this.closeModal();
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
        catchException(e);
      }
    },
    validateMobileNumber(val) {
      return !!val || 'Mobile number is required';
    },
  },
  computed: {
    isContactPersonChangeAllowed: function() {
      if (!this.selectedCustomer || !this.selectedCustomer.isAdult) {
        return false;
      }

      if (this.selectedCustomer.mobileNumber) {
        return true;
      }

      const validationResult = this.validateMobileNumber(this.mobileNumberForNewContactPerson);

      return !!validationResult && typeof validationResult !== 'string';
    },
  },
};
</script>

<style scoped>
.status-message {
  color: red;
}
</style>
